module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/instagram/sola_sns_05-e0e168eb1d25b3cb802610416c004660.jpg";